import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'face-angry',
  size: 24,
  node: [
    ['path', { d: 'M15 12v-1.584', key: '1md67h' }],
    ['path', { d: 'M17 10a5 5 0 00-3 1', key: '1dqs4m' }],
    ['path', { d: 'M7 10a5 5 0 013 1', key: '1okmnq' }],
    ['path', { d: 'M9 12v-1.584', key: 'cfo04w' }],
    ['path', { d: 'M9 17a5 5 0 016.001 0', key: 'ipdrmp' }],
    ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ],
  aliases: ['angry'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name FaceAngry
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTJ2LTEuNTg0IiAvPgogIDxwYXRoIGQ9Ik0xNyAxMGE1IDUgMCAwMC0zIDEiIC8+CiAgPHBhdGggZD0iTTcgMTBhNSA1IDAgMDEzIDEiIC8+CiAgPHBhdGggZD0iTTkgMTJ2LTEuNTg0IiAvPgogIDxwYXRoIGQ9Ik05IDE3YTUgNSAwIDAxNi4wMDEgMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/face-angry
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FaceAngry = createLucideIcon(__iconData);

export default FaceAngry;
